import React, { useState } from "react";
import { Search as SearchIcon } from "lucide-react";
import "./SearchProduct.scss";

const SearchProduct = ({ products, onSelectProduct }) => {
  const [search, setSearch] = useState("");
  return (
    <div className="product-search">
      <div className="product-search__field">
        <span className="product-search__icon" aria-hidden>
          <SearchIcon size={18} strokeWidth={2.25} />
        </span>
        <input
          type="text"
          className="product-search__input"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          aria-label="חיפוש מוצר"
        />
      </div>
      <div className="product-items">
        {search.length > 2
          ? products.map((element, index) =>
              element.ProductName && element.ProductName.includes(search) ? (
                <div
                  key={index}
                  className="product-item"
                  onClick={() => {
                    onSelectProduct(element.Mkt);
                    setSearch("");
                  }}
                >
                  <p>{element.ProductFullDescription}</p>
                </div>
              ) : null,
            )
          : null}
      </div>
    </div>
  );
};
export default SearchProduct;
